import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1355c751"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "periodontal-reports" }
const _hoisted_2 = { class: "periodontal-reports__creation" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Новый отчет ")
const _hoisted_4 = {
  key: 0,
  class: "periodontal-reports__creation-text"
}
const _hoisted_5 = { class: "periodontal-reports__reports" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "periodontal-reports__report-header" }
const _hoisted_8 = { class: "periodontal-reports__report-date" }
const _hoisted_9 = { class: "periodontal-reports__report-number" }
const _hoisted_10 = { class: "divider" }

import { computed, onMounted, ref, watch } from 'vue'
import {
  useOrganizationModules,
  useReportListing,
  useUser,
} from '@/shared/composables'
import { useRoute, useRouter } from 'vue-router'
import { getDateDistance, getDateFormat } from '@/shared/utils'
import { DATE_FORMAT } from '@/shared/constants'
import { brushReportApi } from '@/shared/api/report/brushReport.api'

interface BrushMapReport {
  id: number
  date_at: string
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { user } = useUser()
const { isReportListingUpdated, setUpdateReportListing } = useReportListing()

const route = useRoute()
const router = useRouter()

const reports = ref<BrushMapReport[]>([])
const loading = ref(false)

const patientId = computed(() => Number(route.params.patientId))
const activeReportId = computed(() => Number(route.params.reportId))
const isPreviewMode = computed(() => route.query['view-mode'] === '1')
const { organizationModules } = useOrganizationModules()
const isSubscriptionEnded = computed(() => {
  return (
    !getDateDistance(user.value.organization.block_at) ||
    organizationModules.value.indexOf('brushmap') <= -1
  )
})
watch(patientId, (newPatientId, oldPatientId) => {
  if (newPatientId && newPatientId !== oldPatientId) {
    getReports()
  }
})

watch(
  () => isReportListingUpdated.value,
  (isUpdated) => {
    if (isUpdated) {
      getReports()
      setUpdateReportListing(false)
    }
  }
)

const getDate = (date: string): string => {
  return getDateFormat(new Date(date), DATE_FORMAT.dmyLong)
}

const openFirstReport = (): void => {
  const firstReportId = reports.value[0]?.id ?? 0

  if (!firstReportId) return

  handleOpenReportPage(firstReportId)
}

const getReports = async (): Promise<void> => {
  loading.value = true

  reports.value = []

  const [error, response] = await brushReportApi.getReports(patientId.value)

  if (!error) {
    reports.value = response.data.reports

    reports.value.sort((a, b) => {
      if (new Date(a.date_at) > new Date(b.date_at)) {
        return -1
      } else if (new Date(a.date_at) < new Date(b.date_at)) {
        return 1
      } else {
        return 0
      }
    })

    if (!route.path.includes('report')) {
      openFirstReport()
    }
  }

  loading.value = false
}

const handleOpenReportCreationPage = (): void => {
  router.push({
    name: 'BrushMapPage',
    params: { patientId: patientId.value, reportId: 0 },
  })
}

const handleOpenReportPage = async (reportId: number): Promise<void> => {
  if (route.query['view-mode'] === '1') {
    router.push({
      name: 'BrushMapPage',
      params: { patientId: patientId.value, reportId },
      query: { 'view-mode': 1 },
    })
  } else {
    router.push({
      name: 'BrushMapPage',
      params: { patientId: patientId.value, reportId },
    })
  }
}

onMounted((): void => {
  getReports()
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        disabled: _unref(isSubscriptionEnded),
        class: "periodontal-reports__creation-button",
        round: "",
        type: "primary",
        onClick: handleOpenReportCreationPage
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["disabled"]),
      (!_unref(isPreviewMode) && !reports.value.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, " У пациента пока нет ни одного отчёта. Для создания отчета нажмите кнопку “Новый отчет” "))
        : _createCommentVNode("", true)
    ]),
    (reports.value.length)
      ? (_openBlock(), _createBlock(_component_el_divider, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reports.value, (report) => {
        return (_openBlock(), _createElementBlock("div", {
          key: report.id,
          class: "periodontal-reports__report",
          onClick: ($event: any) => (handleOpenReportPage(report.id))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass([{
            'periodontal-reports__report-content--active':
              _unref(activeReportId) === report.id,
          }, "periodontal-reports__report-content"])
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, _toDisplayString(getDate(report.date_at)), 1)
            ]),
            _createElementVNode("p", _hoisted_9, "№" + _toDisplayString(report.id), 1)
          ], 2),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_el_divider)
          ])
        ], 8, _hoisted_6))
      }), 128))
    ])
  ])), [
    [_directive_loading, loading.value]
  ])
}
}

})